__turbopack_context__.v({
  "authorLine": "Reviews-module-scss-module__PB40xW__authorLine",
  "borderBlue": "Reviews-module-scss-module__PB40xW__borderBlue",
  "borderNavy": "Reviews-module-scss-module__PB40xW__borderNavy",
  "borderYellow": "Reviews-module-scss-module__PB40xW__borderYellow",
  "bulletsContainer": "Reviews-module-scss-module__PB40xW__bulletsContainer",
  "closeButton": "Reviews-module-scss-module__PB40xW__closeButton",
  "closeButtonContainer": "Reviews-module-scss-module__PB40xW__closeButtonContainer",
  "ctaButton": "Reviews-module-scss-module__PB40xW__ctaButton",
  "ctaContainer": "Reviews-module-scss-module__PB40xW__ctaContainer",
  "cus_btn": "Reviews-module-scss-module__PB40xW__cus_btn",
  "desktopTitle": "Reviews-module-scss-module__PB40xW__desktopTitle",
  "header_container": "Reviews-module-scss-module__PB40xW__header_container",
  "iframeContainer": "Reviews-module-scss-module__PB40xW__iframeContainer",
  "mobileTitle": "Reviews-module-scss-module__PB40xW__mobileTitle",
  "nextArrow": "Reviews-module-scss-module__PB40xW__nextArrow",
  "photoCard": "Reviews-module-scss-module__PB40xW__photoCard",
  "photoWrapper": "Reviews-module-scss-module__PB40xW__photoWrapper",
  "prevArrow": "Reviews-module-scss-module__PB40xW__prevArrow",
  "reviewContent": "Reviews-module-scss-module__PB40xW__reviewContent",
  "reviewHead": "Reviews-module-scss-module__PB40xW__reviewHead",
  "reviewQuote": "Reviews-module-scss-module__PB40xW__reviewQuote",
  "reviewerDegree": "Reviews-module-scss-module__PB40xW__reviewerDegree",
  "reviewerDetails": "Reviews-module-scss-module__PB40xW__reviewerDetails",
  "reviewerImg": "Reviews-module-scss-module__PB40xW__reviewerImg",
  "reviewerName": "Reviews-module-scss-module__PB40xW__reviewerName",
  "reviewsCarouselWrapper": "Reviews-module-scss-module__PB40xW__reviewsCarouselWrapper",
  "reviewsOnlineContainer": "Reviews-module-scss-module__PB40xW__reviewsOnlineContainer",
  "reviewsOnlineDesc": "Reviews-module-scss-module__PB40xW__reviewsOnlineDesc",
  "reviewsOnlineItem": "Reviews-module-scss-module__PB40xW__reviewsOnlineItem",
  "reviewsOnlineTitle": "Reviews-module-scss-module__PB40xW__reviewsOnlineTitle",
  "sc_btn": "Reviews-module-scss-module__PB40xW__sc_btn",
  "slideWrapper": "Reviews-module-scss-module__PB40xW__slideWrapper",
  "text_caru_container": "Reviews-module-scss-module__PB40xW__text_caru_container",
  "videoModalBox": "Reviews-module-scss-module__PB40xW__videoModalBox",
  "videoModalContainer": "Reviews-module-scss-module__PB40xW__videoModalContainer",
  "videoModalContent": "Reviews-module-scss-module__PB40xW__videoModalContent",
});
